import { useEventTabsConfig } from 'hooks/useEventTabsConfig';

export const useSubmissionType = (eventId: string | null) => {
  const { data: tabsConfig } = useEventTabsConfig(eventId);
  const submissionType =
    { Presentations: 'PRESENTATION', Documents: 'DOCUMENT', Submissions: 'SUBMISSION' }[
      tabsConfig?.submissions?.label || ''
    ] || tabsConfig?.submissions?.label.toUpperCase();

  return submissionType;
};
